import React, { Component } from 'react';

import classes from './FlashMessage.module.css';

class FlashMessage extends Component {
	state = {
		visible: true,
	};

	resumeTimer = () => {
		clearTimeout(this.timer);
		this.start = new Date();
		this.timer = setTimeout(this.hide, this.remaining);
	};

	hide = () => {
		clearTimeout(this.timer);
		this.setState({ visible: false });
	};

	onPause = () => {
		clearTimeout(this.timer);
		this.remaining -= new Date() - this.start;
	};

	render() {
		return this.state.visible ? (
			<div
				className={[classes.FlashMessage, classes[this.props.type]].join(' ')}
				onMouseEnter={this.onPause}
				onMouseLeave={this.resumeTimer}
			>
				<div className={classes.Message}>{this.props.children}</div>
				<button className={classes.Close} onClick={this.hide}>
					&#10006;
				</button>
			</div>
		) : null;
	}

	componentDidMount() {
		this.remaining = this.props.duration;
		this.resumeTimer();
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}
}

export default FlashMessage;
